export default {"src":"/login-app/[GIT_HASH]/_next/static/media/claude.7e69c74a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};